import React from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Button } from "reactstrap";
import cx from "classnames";

import s from "./BackButton.module.scss";

export default function BackButton({ to }) {
	const history = useHistory();

	return !to ? (
		<Button
			color="primary"
			className={cx(s.root, "btn-border")}
			onClick={() => history.goBack()}
		>
			<i className="fa fa-arrow-left" />
			<span>Back</span>
		</Button>
	) : (
		<Link to={to} className={s.root}>
			<Button color="primary" className={"btn-border"}>
				<i className="fa fa-arrow-left" />
				<span>Back</span>
			</Button>
		</Link>
	);
}
